import { useState } from "react";
import "../../assets/css/Signup/Signup.css";
import FullSignup from "../FullSignup/FullSignup";
import SignupOtp from "../SignupOtp/SignupOtp";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useNavigate, Link } from "react-router-dom";

function Signup() {
  const [activeTab, setActiveTab] = useState("otp");

  return (
    <>
      <Header showProfile={false} />
      <div className="signnup_container">
        <div className="card_signup_card">
          {/* ---------- CARD HEADER TABS ---------- */}
          <div className="card-header">
            <ul className="nav nav-tabs card-header-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "otp" ? "active" : ""}`}
                  onClick={() => setActiveTab("otp")}
                >
                  Quick Signup
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === "full" ? "active" : ""}`}
                  onClick={() => setActiveTab("full")}
                >
                  Standard Signup
                </button>
              </li>
            </ul>
          </div>

          {/* ---------- CARD BODY ---------- */}
          <div className="card-body">
            {activeTab === "otp" && <SignupOtp />}
            {activeTab === "full" && <FullSignup />}
          </div>
        </div>

        <div className="login_redirect">
          Already have an account? <Link to="/">Log in</Link>
        </div>
      </div>
      <Footer />
    </>

  );
}

export default Signup;